import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonRouteComponent } from "./sidebar-button-route.component";

@Component({
    selector: "sidebar-lists",
    imports: [],
    templateUrl: "./sidebar-button-route.component.html"
})
export class SidebarListsButtonComponent extends SidebarButtonRouteComponent {
    public constructor() { 
        super("Lists", SvgIcon.Lists, "lists", true); 
    }
}